import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { InstallTab } from "@/components/InstallTab";
import { RealtimeVoiceOrb } from "@/components/RealtimeVoiceOrb";
import { AvaOrb } from "@/components/AvaOrb";
import { GlobalPlayerFitness } from "@/components/PlayerFitnessModal";

export const Layout = () => {
  return (
    <div className="vignette relative min-h-screen bg-[#050505]">
      <Sidebar />
      <main
        data-octon-main
        className="relative z-10 min-h-screen"
        style={{
          paddingTop: "env(safe-area-inset-top, 0px)",
          paddingLeft: "env(safe-area-inset-left, 0px)",
          paddingRight: "env(safe-area-inset-right, 0px)",
          paddingBottom: "env(safe-area-inset-bottom, 0px)",
        }}
      >
        <Outlet />
      </main>
      <InstallTab />
      <RealtimeVoiceOrb />
      <AvaOrb />
      <GlobalPlayerFitness />
    </div>
  );
};
